module.exports = __webpack_public_path__ + "static/img/forget.77748d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/forget.png
// module id = yQ07
// module chunks = 1